import { useEffect, useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { latestNews } from '@/mocks/homeData';

const fullArticleContent: Record<number, { content: string[]; author: string }> = {
  1: {
    author: '体育观察员',
    content: [
      '2026赛季英超联赛即将全面打响，各支球队经过夏季转会窗的调整后，新赛季的争冠格局呈现出前所未有的激烈态势。',
      '卫冕冠军曼城在瓜迪奥拉的带领下，保持着令人窒息的统治力。尽管今夏失去了一位核心中场，但球队深厚的阵容底蕴和成熟的战术体系，依然使他们成为新赛季的最大热门。哈兰德的状态持续火热，挪威射手在新赛季的进球效率令人期待。',
      '阿森纳在阿尔特塔的精心打造下，青年军已经成长为英超最具竞争力的球队之一。上赛季与冠军擦肩而过的遗憾，将成为年轻枪手们前进的动力。萨卡、厄德高等核心球员正值巅峰期，球队的整体实力稳中有升。',
      '利物浦在克洛普离开后迎来了新时代，新任主帅带来的战术变化正在逐步显现。球队在保留核心框架的同时，进行了针对性的补强。新赛季的红军依然是争冠集团中不可忽视的力量。',
      '除了传统豪强之外，纽卡斯尔联和阿斯顿维拉等球队也在持续崛起。充裕的资金支持和科学的管理运营，让这些球队具备了挑战传统格局的底气。新赛季英超的竞争将更加激烈，每一轮比赛都充满悬念。',
      '从赔率角度来看，曼城以1.85的夺冠赔率领跑，阿森纳以4.20紧随其后，利物浦以5.50位列第三。这样的赔率分布充分反映了新赛季英超争冠格局的复杂性和不确定性。',
    ],
  },
  2: {
    author: '篮球深度报道',
    content: [
      '2026年NBA休赛期交易市场风起云涌，多位全明星级别的球员通过交易或自由签约的方式改换门庭，联盟格局因此发生了深刻变化。',
      '最引人关注的交易发生在洛杉矶湖人队。湖人在休赛期通过一笔重磅交易得到了一位顶级后卫，与勒布朗·詹姆斯和安东尼·戴维斯组成了新的三巨头阵容。这一操作让湖人队的夺冠赔率从1.65大幅下降，成为了新赛季总冠军的最有力竞争者。',
      '金州勇士队在失去克莱·汤普森后，通过一系列精准操作完成了阵容重组。库里依然是球队的灵魂核心，而新加入的年轻球员为球队注入了新的活力。勇士队的灵活打法和三分球主导的进攻体系仍然是联盟中最具观赏性的。',
      '东部方面，波士顿凯尔特人保持了核心阵容的稳定，塔图姆和布朗的双探花组合继续领衔。密尔沃基雄鹿在字母哥的带领下，依然是东部最具威胁的球队之一。东西部实力的均衡，预示着新赛季将充满精彩对决。',
      '根据最新赔率数据，湖人以1.65的夺冠赔率位居联盟第一，凯尔特人以1.90紧随其后，勇士以2.30位列西部第二。这些赔率反映了各队在休赛期操作后的实力变化，也为球迷提供了重要的参考依据。',
    ],
  },
  3: {
    author: '电竞产业观察',
    content: [
      '全球电竞产业在2026年迎来了新的发展高峰，市场规模预计突破200亿美元大关，展现出令人瞩目的增长势头。',
      '从区域发展来看，亚洲依然是全球最大的电竞市场，其中中国、韩国和东南亚地区是增长的核心引擎。中国电竞市场凭借庞大的用户基础和日益完善的产业生态，继续保持全球领先地位。LPL联赛的商业价值和国际影响力不断提升。',
      '北美和欧洲电竞市场也在稳步增长。VALORANT、CS2等射击类电竞项目在欧美地区拥有广泛的受众基础，赛事体系日益成熟。游戏开发商和赞助商的持续投入，为电竞产业的长期发展提供了坚实保障。',
      '在商业模式方面，电竞产业的收入来源日益多元化。除了传统的媒体版权和赞助收入外，虚拟商品销售、粉丝经济和衍生品开发成为新的增长点。电竞与区块链、元宇宙等新兴技术的融合，也为行业带来了更多想象空间。',
      '开云体育在线平台深耕电竞领域，覆盖LOL、DOTA2、CS2、王者荣耀等热门电竞赛事，提供专业的赛事数据分析和实时赔率服务，为电竞爱好者打造一流的投注体验。',
    ],
  },
  4: {
    author: '网球专栏作家',
    content: [
      '温布尔登网球锦标赛作为网球运动中最具声望和历史底蕴的赛事，见证了无数传奇对决的诞生。让我们一同回顾那些永载史册的经典时刻。',
      '2008年温网男单决赛，费德勒与纳达尔上演了被誉为"史上最伟大比赛"的史诗对决。经过4小时48分钟的激战，纳达尔以6-4、6-4、6-7、6-7、9-7的比分艰难取胜，终结了费德勒在温网的五连冠纪录。那场比赛不仅是技术的较量，更是意志力的巅峰对决。',
      '2019年温网男单决赛同样堪称经典，德约科维奇与费德勒大战5小时，最终在决胜盘抢七中以13-12惊险获胜。这场比赛创造了温网历史上最长的男单决赛纪录，德约科维奇挽救两个冠军点的表现令人叹为观止。',
      '在女子方面，小威廉姆斯在温网的统治力同样令人敬畏。她七次夺得温网女单冠军的成绩，塑造了女子网坛的标杆。草地之王的传承在不同时代的球员之间延续，每一位温网冠军都在书写属于自己的传奇。',
      '从费德勒的优雅单反，到纳达尔的顽强斗志，再到德约科维奇的全面统治，温网的草地上永远不缺感动与传奇。',
    ],
  },
  5: {
    author: '开云体育编辑部',
    content: [
      '在数字化转型的时代背景下，网络安全已成为在线体育平台最重要的基础设施之一。开云体育在线始终将用户信息安全放在首位，近期完成了安全系统的全面升级。',
      '此次安全升级采用了银行级SSL加密技术，所有用户数据在传输和存储过程中都经过多层加密处理。系统采用256位AES加密算法，确保用户的个人信息、账户余额和交易记录得到最严格的保护。',
      '在账户安全方面，开云体育在线引入了多重身份验证机制。除了传统的密码登录外，用户还可以开启手机验证码、邮箱验证码和人脸识别等二次验证方式，大幅提升账户安全性。系统还会实时监测异常登录行为，一旦发现可疑操作立即触发安全预警。',
      '资金安全是用户最为关注的核心问题。开云体育在线采用独立资金托管机制，用户资金与平台运营资金严格分离。所有资金流转均通过持牌支付机构处理，全程可追溯、可审计。平台还购买了巨额资金安全保险，为用户资金提供双重保障。',
      '开云体育在线将持续投入资源升级安全基础设施，用技术手段为每一位用户构建安全的体育娱乐环境。您的信任，是我们最大的责任。',
    ],
  },
  6: {
    author: '乒乓球赛事记者',
    content: [
      '2026年世界乒乓球锦标赛圆满落下帷幕，中国乒乓球队再次展现强大实力，包揽了全部五项冠军，延续了国球荣耀的辉煌传统。',
      '在男单赛场，中国队展现出了令人窒息的统治力。经过多轮激烈角逐，中国选手包揽了男单四强，最终世界排名第一的头号种子以4-1的比分战胜队友，成功卫冕男单冠军。女单方面同样是中国队的内战，最终上届亚军以4-2逆转取胜，首次夺得世锦赛女单冠军。',
      '男双和女双项目中，中国组合配合默契、技术全面，均以不失一局的完美战绩夺冠。混双项目由中国新生代组合摘得桂冠，展现了国乒梯队建设的卓越成果。',
      '从技战术角度来看，中国乒乓球队在本次世锦赛中展现出了几个明显趋势：一是反手技术的全面升级，二是速度与旋转的结合更加精细，三是年轻选手的大赛心态日益成熟。这些因素共同构成了国乒持续领先的核心竞争力。',
      '本届世锦赛的全面胜利，为中国乒乓球队备战未来的国际大赛奠定了坚实基础。开云体育在线将继续关注乒乓球赛事动态，为球迷提供最新的赛事资讯和专业分析。',
    ],
  },
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const articleId = parseInt(id || '1', 10);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [articleId]);

  const article = useMemo(() => latestNews.find((n) => n.id === articleId), [articleId]);
  const fullContent = useMemo(() => fullArticleContent[articleId], [articleId]);
  const relatedArticles = useMemo(
    () => latestNews.filter((n) => n.id !== articleId).slice(0, 3),
    [articleId]
  );

  if (!article || !fullContent) {
    return (
      <>
        <Navbar />
        <main className="pt-16 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-file-unknow-line text-2xl text-foreground-400"></i>
            </div>
            <p className="text-sm text-foreground-500">文章未找到</p>
            <Link to="/" className="mt-4 inline-block text-sm text-primary-500 hover:text-primary-600 whitespace-nowrap">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <article>
          <div className="bg-background-950 py-10 md:py-14">
            <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
              <nav className="flex items-center gap-1.5 text-xs mb-4" aria-label="面包屑导航">
                <Link to="/" className="text-background-400 hover:text-background-200 transition-colors duration-200 whitespace-nowrap">首页</Link>
                <span className="text-background-500">/</span>
                <span className="text-background-400 whitespace-nowrap">体育资讯</span>
                <span className="text-background-500">/</span>
                <span className="text-background-200 whitespace-nowrap line-clamp-1">{article.title}</span>
              </nav>

              <div className="inline-block px-2 py-0.5 text-[10px] font-medium bg-accent-500/90 text-background-950 rounded mb-4 whitespace-nowrap">
                {article.category}
              </div>

              <h1 className="text-xl md:text-3xl font-heading font-bold text-background-50 leading-tight mb-4">
                {article.title}
              </h1>

              <div className="flex items-center gap-4 text-xs text-background-400">
                <div className="flex items-center gap-1.5">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-user-line"></i>
                  </div>
                  <span>{fullContent.author}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-calendar-line"></i>
                  </div>
                  <span>{article.date}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-time-line"></i>
                  </div>
                  <span>{article.readTime}阅读</span>
                </div>
              </div>
            </div>
          </div>

          <div className="py-10 md:py-14 bg-background-50">
            <div className="w-full px-4 md:px-6 max-w-[800px] mx-auto">
              <div className="prose-custom">
                {fullContent.content.map((paragraph, idx) => (
                  <p key={idx} className="text-sm md:text-base text-foreground-800 leading-relaxed mb-5">
                    {paragraph}
                  </p>
                ))}
              </div>

              <div className="mt-10 pt-8 border-t border-background-200/60">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">标签：</span>
                  <span className="px-2 py-0.5 text-[10px] bg-background-100 text-foreground-600 rounded whitespace-nowrap">{article.category}</span>
                  <span className="px-2 py-0.5 text-[10px] bg-background-100 text-foreground-600 rounded whitespace-nowrap">开云体育在线</span>
                </div>
              </div>
            </div>
          </div>

          {relatedArticles.length > 0 && (
            <div className="py-10 md:py-14 bg-background-100">
              <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-6">相关文章</h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  {relatedArticles.map((rel) => (
                    <Link
                      key={rel.id}
                      to={`/article/${rel.id}`}
                      className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300"
                    >
                      <div className="relative h-32 overflow-hidden">
                        <img
                          src={rel.image}
                          alt={rel.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-3">
                        <h4 className="text-xs font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200 leading-snug">
                          {rel.title}
                        </h4>
                        <div className="flex items-center gap-2 mt-2 text-[10px] text-foreground-500">
                          <div className="w-2.5 h-2.5 flex items-center justify-center">
                            <i className="ri-calendar-line"></i>
                          </div>
                          <span>{rel.date}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          )}
        </article>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            author: { '@type': 'Person', name: fullContent.author },
            datePublished: article.date,
            description: article.excerpt,
            publisher: { '@type': 'Organization', name: '开云体育在线' },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.kaiyunsport.com/' },
              { '@type': 'ListItem', position: 2, name: '体育资讯', item: 'https://www.kaiyunsport.com/' },
              { '@type': 'ListItem', position: 3, name: article.title },
            ],
          }),
        }}
      />
    </>
  );
}